// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3mK3z","checkboxCol":"Table_checkboxCol__EuU_W","emailCol":"Table_emailCol__1ULW_","actionCol":"Table_actionCol__1_tSh"};